import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { ScormTypes } from './types';

export const startCDNTestRequest = () => action(ScormTypes.START_CDN_TEST_REQUEST);
export const startCDNTestSuccess = (data: string) => action(ScormTypes.START_CDN_TEST_SUCCESS, data);
export const startCDNTestFailure = (error: AxiosError) => action(ScormTypes.START_CDN_TEST_FAILURE, error);
export const startCDNTestClear = () => action(ScormTypes.START_CDN_TEST_CLEAR);
